import type { PrivatePensionPosition } from '../../interface/Position';
import { useQuery } from '@tanstack/react-query';
import { setupPositionAPIClient } from '@/libs/axios/positionAPI';
import { apiConfig } from '@/config/api';

const getPrevPositions = async (accountId?: string | null) => {
  const positionAPI = setupPositionAPIClient();
  const { data } = await positionAPI.get<{
    data: PrivatePensionPosition[];
  }>(apiConfig.routes.walletPosition.privatePension.position, {
    params: {
      beneficiaryDocument: accountId,
    },
  });
  return data.data;
};

export const useGetPrevPositions = (accountId?: string | null) =>
  useQuery({
    queryKey: ['privatePension', 'positions', accountId],
    queryFn: () => getPrevPositions(accountId),
    select: (data) => ({
      positions: data,
      balance: data.reduce(
        (acc, { consolidatedValues }) => acc + consolidatedValues,
        0
      ),
    }),
  });
